import { render } from "./PDAnalytics.vue?vue&type=template&id=e5cf1ca4&scoped=true"
import script from "./PDAnalytics.vue?vue&type=script&lang=ts"
export * from "./PDAnalytics.vue?vue&type=script&lang=ts"

import "./PDAnalytics.vue?vue&type=style&index=0&id=e5cf1ca4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e5cf1ca4"

export default script